import { FlexiLogicResult } from '@customer-apps/flexi-logic';

export class TranslationUtils {
    static sanitizeTranslationParams(value: FlexiLogicResult | null): Record<string, string | number | boolean> | undefined {
        if (!value || typeof value !== 'object' || Array.isArray(value)) {
            return undefined;
        }

        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, v ?? '']));
    }

    static localizeNumericParams(
        params: Record<string, string | number | boolean> | undefined,
        decimalSeparator: string
    ): Record<string, string | number | boolean> | undefined {
        if (!params) {
            return params;
        }

        return Object.fromEntries(
            Object.entries(params).map(([key, value]) => [
                key,
                typeof value === 'number' ? value.toString().replace('.', decimalSeparator) : value
            ])
        );
    }
}
